import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { BackButton } from 'app/components/ui/BackButton';

import './mobile-cart-header.scss';
import { UIHeading } from '../ui';
import { isGlobalLoadingVar } from 'app/apollo/reaction';
import { useReactiveVar } from '@apollo/client';


const noop = () => {};


const MobileCartHeader = ({
    isLeftBlockShown = true,
    onClickBack = noop,
    position = 'static',
    realm = 'default',
}) => {
    const isGlobalLoading = useReactiveVar(isGlobalLoadingVar);
    const rootClasses = classNames({
        'mobile-cart-header__root': true,
    });
    const isEditBasketBlock = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hideParams = urlParams.get('hide') || '';
        const param = hideParams || '';
        return param?.includes('edit_basket');
    }, []);

    return (
        <div styleName={rootClasses} style={{ position }}>
            <div styleName="basket-header-back-button-wrapper">
                {isLeftBlockShown && !isEditBasketBlock && <BackButton onClick={onClickBack} justify="start" disabled={isGlobalLoading} />}
                {realm === 'basket' && (
                    <div styleName="basket-header-title-wrapper">
                        <UIHeading level="3.2">
                            Корзина
                        </UIHeading>
                    </div>
                )}
            </div>
        </div>
    );
};

MobileCartHeader.propTypes = {
    onClickBack: PropTypes.func,
    isLeftBlockShown: PropTypes.bool,
    position: PropTypes.string,
    realm: PropTypes.string,
};

export default MobileCartHeader;
